import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { allNews, formatDate, formatViews } from "@/lib/content";

export default function NewsHighlights() {
  const latest = [...allNews].sort((a, b) => b.date.localeCompare(a.date)).slice(0, 5);

  return (
    <section className="mb-14">
      <SectionHeading
        title="最新资讯快览"
        subtitle="影视资讯、作品动态与人物访谈，第一时间掌握"
        moreTo="/news"
        moreLabel="全部资讯"
      />
      <div className="flex flex-col divide-y divide-background-200 border border-background-200 rounded-lg overflow-hidden bg-background-50">
        {latest.map((news, index) => (
          <Link
            key={news.id}
            to={`/news/${news.id}`}
            className="group flex items-center gap-4 p-4 hover:bg-background-100 transition-colors"
          >
            <span
              className={`shrink-0 w-7 h-7 rounded-md flex items-center justify-center text-xs font-bold ${
                index < 3 ? "bg-accent-500 text-background-50" : "bg-background-200 text-foreground-600"
              }`}
            >
              {index + 1}
            </span>
            <div className="w-24 h-16 md:w-32 md:h-20 shrink-0 rounded-md overflow-hidden bg-background-200">
              <img
                src={news.cover}
                alt={`${news.title}配图`}
                title={`${news.title} - 筱田优影视资讯`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-sm md:text-base font-medium text-foreground-900 line-clamp-2 group-hover:text-primary-600 transition-colors">
                {news.title}
              </h3>
              <div className="flex items-center gap-3 mt-2 text-xs text-foreground-400">
                <span>{formatDate(news.date)}</span>
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line" />
                  {formatViews(news.views)}
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}